export default __webpack_public_path__ + "static/media/segre21.0d6c50f2.jpg";